// In this price management table, data is stored in react hook form in the following structure
// itemId, extension instance id, price band id
// separated by * eg:
// 123*null*null this id is an item default price as there is no extension instance and price band id
// 123*456*789 this id is for an extension instance and a price band price
// 123*null*789 this id is for a price band default price
// 123*456*null this id is for an extension instance default price
// if a product hasn't got a price for a field, it is stored against an id as an empty string

import { DELIMITER } from './constants';
import { IPricingChannel } from 'src/helpers/channels/getPricingChannels';
import { IPriceBandWithVenues } from 'src/types/priceBand.types';
import { IItemIdWithPrices } from './types';

// placeholders are used to display the "fallback prices"
export const generatePriceFormDefaults = (
  products: IItemIdWithPrices[],
  priceBands: IPriceBandWithVenues[],
  pricingChannels: IPricingChannel[],
) => {
  const defaults = {};

  products?.forEach((product) => {
    const productDefaultPrice = product.prices.find(
      (price) => price.price_band_id === null && price.extension_instance_id === null,
    );

    //set product default price
    defaults[`${product.item_id}${DELIMITER}${null}${DELIMITER}${null}`] =
      productDefaultPrice?.value_with_tax.toFixed(2) || '';

    priceBands?.forEach(({ priceBandId, name: priceBandName }) => {
      // if not default price band, add default price band price to form state
      if (priceBandName !== 'Default') {
        const productDefaultPricebandPrice = product.prices.find(
          (price) => price.price_band_id === priceBandId && price.extension_instance_id === null,
        );

        defaults[`${product.item_id}${DELIMITER}null${DELIMITER}${priceBandId}`] =
          productDefaultPricebandPrice?.value_with_tax.toFixed(2) || '';
      }

      pricingChannels.forEach(({ extensionInstanceId }) => {
        const extensionInstancePrice = product.prices.find(
          (price) => price.extension_instance_id === extensionInstanceId && price.price_band_id === priceBandId,
        );

        defaults[`${product.item_id}${DELIMITER}${extensionInstanceId}${DELIMITER}${priceBandId}`] =
          extensionInstancePrice?.value_with_tax.toFixed(2) || '';
      });
    });
  });
  return defaults;
};
